export default __webpack_public_path__ + "static/media/practice-level-2.d440cee3.svg";